// WorldNewsSection.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom"; // Import Link
import "./WorldNewsSection.css";

const WorldNewsSection = () => {
  // Local state to hold the fetched data
  const [newsItems, setNewsItems] = useState([]);

  // useEffect to fetch data from your endpoint when component mounts
  useEffect(() => {
    axios
      .get("https://khanehyeghtesad.com:8000/api/article/top/")
      .then((response) => {
        // response.data is your array of articles
        setNewsItems(response.data);
      })
      .catch((error) => {
        console.error("Error fetching top articles:", error);
      });
  }, []); // Empty deps array => runs once on mount

  return (
    <section className="world-news-section-word">
      {/* Section Title */}
      <h2 className="section-title">
        اخبار پربازدید
        <span className="underline-word"></span>
      </h2>

      {/* News Grid */}
      <div className="news-grid-word">
      
        {newsItems.map((item) => (
          
          <Link
          
            to={`/article/${item.slug}`} // Adjust the path based on your route configuration
            key={item.slug}
            className="news-item-link-word" // Optional: Add a class for styling
          >
            <div className="news-item-word">
              {/* Display base64 image */}
              <img
                src={
                  item.image_file
                    ? `data:image/jpeg;base64,${item.image_file}`
                    : "https://via.placeholder.com/300x200"
                }
                alt={item.title}
                className="news-image-word"
              />
              <p className="news-quote-latest">{item.quote}</p>
              <h3 className="news-title-word">{item.title}</h3>
              <p className="news-date-word">{item.jalali_full_date}</p>
              {/* Optional: Display categories */}
              {item.category && item.category.length > 0 && (
                <p className="news-category-word">{item.category.join(" - ")}</p>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default WorldNewsSection;
